// // 模块的GIS逻辑
import Util from './Util';
import Service from '../../../service/ServiceFactory';

const componentBase = (G as any).base.ComponentBase;
const component = componentBase.extend({
    // 属性
    options: {
        highLightId: 'search_highlight', // 高亮id
        tempHighLightId: 'temp_highlight',
        popupId: 'popup_search_comp', // 弹窗唯一标识
        msgId: 'msg_popup',
        popupEventName: 'popup', // 详情框事件名
        featureType: 'search_comp', // 图层标识
        bufferLayer: 'around_buffer_comp', // 范围图层标识,
        bufferDraw: null,
        mapConfig: { center: [108.940764, 34.278987], zoom: 5 }, // 中国视野
    },
    // 初始化
    initialize(options: any) {
        componentBase.prototype.initialize.call(this, options);
        this.map.on('drag', () => {
            this.fire('drag', this.map.getExtent());
        });
        this.wpssService = this.wpssService || this._createService('RestWPSSService');
        this.wrgsService = this.wrgsService || this._createService('RestWRGSService');
    },
    //  销毁
    destroy() {
        componentBase.prototype.destroy.call(this);
    },
    /**
     * 根据查询结果渲染地图
     * @param data {object} 搜索结果
     * @param location  {string} 缓冲查询的中心点位
     * @param radius {number} 缓冲查询半径
     */
    load(data: any, location?: string, radius?: number) {
        componentBase.prototype.load.call(this);
        if (!!data) {
            this._load(data);
        }
        if (!!location && !!radius) {
            this._addBuffer(location, radius);
        }
    },

    /**
     * 关键词搜索
     * @param keyword 关键词(required)
     * @param query_type 搜索类型：1:建议词搜索，2:POI搜索(optional, default to 2)
     * @param region 行政区划，可输入城市名、行政区划名(optional, default to '')
     * @param source 搜索来源：baidu 百度；tianditu 天地图；all 所有；(optional, deault to all)
     * @param page_size 每页返回POI数量(optional, default to 10)
     * @param page_num 分页页码，默认为0,0代表第一页 (optional, default to 0)
     */
    keywordSearch(opts: any) {
        const keywordInput = new egis.ews.KeywordInput({
            keyword: opts.keyword,
            query_type: opts.query_type || 2,
            source: opts.source || 'all',
            level: Math.round(this.map.getZoomLevel()),
            bounds: this.map.getExtent(),
            region: opts.region || '',
            scope: 2,
            page_size: opts.page_size || 10,
            page_num: opts.page_num || 0,
        });
        return new Promise((resolve, reject) => {
            this.wpssService.keyWord(keywordInput).then((response: any) => {
                resolve(response);
            });
        });
    },

    /**
     * 周边搜索
     * @param keyword 关键词(required)
     * @param query_type 搜索类型：1:建议词搜索，2:POI搜索
     * @param location 中心点坐标，经度和纬度用","分割，经度在前，纬度在后，坐标系为CGCS2000(required)
     * @param region 行政区划，可输入城市名、行政区划名
     * @param radius 搜索半径，单位米(optional, default to 10km)
     * @param source 搜索来源：baidu 百度；tianditu 天地图；all 所有；
     * @param page_size 每页返回POI数量
     * @param page_num 分页页码，默认为0,0代表第一页
     */
    // tslint:disable-next-line: variable-name
    aroundSearch(opts: any) {
        const aroundInput = new egis.ews.AroundInput({
            keyword: opts.keyword,
            query_type: opts.query_type || 2,
            source: opts.source || 'all',
            level: Math.round(this.map.getZoomLevel()),
            location: opts.location,
            radius: opts.radius || 10000,
            bounds: this.map.getExtent(),
            region: opts.region || '',
            scope: 2,
            page_size: opts.page_size || 10,
            page_num: opts.page_num || 0,
        });
        return new Promise((resolve, reject) => {
            this.wpssService.around(aroundInput).then((response: any) => {
                resolve(response);
            });
        });
    },

    /**
     * 矩形范围搜索
     * @param keyword 关键词
     * @param query_type 搜索类型：1:建议词搜索，2:POI搜索
     * @param region 行政区划，可输入城市名、行政区划名
     * @param source 搜索来源：baidu 百度；tianditu 天地图；all 所有；
     * @param page_size 每页返回POI数量
     * @param page_num 分页页码，默认为0,0代表第一页
     */
    // tslint:disable-next-line: variable-name
    boundsSearch(opts: any) {
        const boundsInput = new egis.ews.BoundsInput({
            keyword: opts.keyword,
            query_type: opts.query_type || 2,
            source: opts.source || 'all',
            level: Math.round(this.map.getZoomLevel()),
            bounds: this.map.getExtent(),
            region: opts.region || '',
            scope: 2,
            page_size: opts.page_size || 10,
            page_num: opts.page_num || 0,
        });
        return new Promise((resolve, reject) => {
            this.wpssService.bounds(boundsInput).then((response: any) => {
                resolve(response);
            });
        });
    },

    currentLevel() {
        return Math.round(this.map.getZoomLevel());
    },

    locate(location: any) {
        if (!!location) {
            const center = new egis.sfs.Point({
                x: !!location.x ? location.x : Number(!!location.lng ? location.lng : location.split(',')[0]),
                y: !!location.y ? location.y : Number(!!location.lat ? location.lat : location.split(',')[1]),
                spatialReference: egis.sfs.EnumSpatialReference.EPSG4326,
            });
            this.map.pan(center);
        }
    },

    unload() {
        this.options.simpleRenderMgr.remove(this.options.featureType);
        this.closePopup();
        this.removehighlight();
        if (this.polygonFeatureLayer) { this.polygonFeatureLayer.clear(); }
        if (this.options.bufferDraw) {
            this.options.bufferDraw.destroy();
            this.options.bufferDraw = null;
        }
        componentBase.prototype.unload.call(this);
    },

    addListeners() {
        // 添加事件监听，load调用时父类触发
    },

    removeListeners() {
        // 移除事件监听，unload调用时父类触发
        // this.map.off('click', () => {
        //     console.log('map click');
        // });
    },

    openPopup(element: any, isClick = true) {
        this.options.popupManager.addSimple({
            id: isClick ? this.options.popupId : this.options.msgId,
            anchor: element.hasOwnProperty('$type') ? [element.geometry.x, element.geometry.y] : [element.location.x, element.location.y],
            className: 'demo-tooltip',
            offset: [20, -35],
            layerId: 'test',
        }).then((content: any) => {
            this.fire(this.options.popupEventName, {
                data: element.hasOwnProperty('$type') ? Util.attributeSet2Object(element.attributeSet) : element,
                containerId: content.containerId,
                type: 'demo',
            });
        });
    },

    closePopup(isClick = true) {
        const popupId = isClick ? this.options.popupId : this.options.msgId;
        this.options.popupManager.remove(popupId);
    },

    // 添加高亮
    highLight(data: any, num: number, isClick = true) {
        this.removehighlight(isClick);
        if (!!data && !!num) {
            const x = !!data.location.x ? data.location.x : Number(data.location.lng);
            const y = !!data.location.y ? data.location.y : Number(data.location.lat);
            this._addHighlight(x, y, num, isClick);
        }
    },

    // 移除高亮
    removehighlight(isClick = true) {
        const highLightId = isClick ? this.options.highLightId : this.options.tempHighLightId;
        this.options.featureHighlight.removeHighlight(highLightId);
    },

    async _load(data: any) {
        const opts: any = {};
        this.options.simpleRenderMgr.remove(this.options.featureType);
        opts.featureType = this.options.featureType;
        if (!!data && !!data.type) {
            switch (data.type) {
                case 2:
                    // 渲染聚合
                    opts.idField = 'admin_code';
                    opts.list = data.statistics.admins; // 数据列表
                    opts.type = 1; // 使用feature渲染
                    opts.geometryBuilder = new this.options.PointGeometryBuilder({
                        geometryField: ['location.x', 'location.y'],
                    });
                    const SymbolBuilderc = (G as any).utils.SymbolBuilder.extend({
                        // tslint:disable-next-line: no-shadowed-variable
                        build: (data: any) => {
                            return new egis.sfs.CurrencySymbol({
                                markerSymbol: new egis.sfs.SimpleMarkerSymbol({
                                    size: data.count < 1000 ? 15 : count < 10000 ? 18 : 23,
                                    style: 'circle',
                                    fillColor: new egis.sfs.Color({ r: 200, g: 0, b: 0, a: 153 }),
                                    borderColor: new egis.sfs.Color({ r: 200, g: 0, b: 0, a: 153 }),
                                    borderThickness: 3,
                                }),
                                textSymbol: new egis.sfs.TextSymbol({
                                    text: data.count.toString(),
                                    foreground: new egis.sfs.Color({ r: 255, g: 255, b: 255, a: 255 }),
                                    borderColor: new egis.sfs.Color({ r: 255, g: 255, b: 255, a: 255 }),
                                    fontFamilyName: '黑体',
                                    fontSize: 20,
                                    borderThickness: 1,
                                }),
                            });
                        },
                    });
                    opts.symbolBuilder = new SymbolBuilderc();
                    this.options.simpleRenderMgr.add(opts);
                    this._fit();
                    break;
                case 3:
                    // 渲染poi点
                    let count = 0;
                    opts.idField = 'uid'; // 数据唯一标识的属性
                    opts.list = data.pois; // 数据列表
                    opts.type = 1; // 使用feature渲染
                    opts.geometryBuilder = new this.options.PointGeometryBuilder({
                        geometryField: ['location.x', 'location.y'],
                    });
                    const SymbolBuilder = (G as any).utils.SymbolBuilder.extend({
                        // tslint:disable-next-line: no-shadowed-variable
                        build: (data: any) => {
                            return new egis.sfs.CurrencySymbol({
                                markerSymbol: new egis.sfs.PictureMarkerSymbol({
                                    width: 22,
                                    height: 34,
                                    offsetX: 11,
                                    offsetY: 34,
                                    opacity: '1',
                                    rotation: '0',
                                    source: this.options.symbolConfig.icons.little_red_poi,
                                }),
                                textSymbol: new egis.sfs.TextSymbol({
                                    text: (++count).toString(),
                                    foreground: new egis.sfs.Color({ r: 255, g: 255, b: 255, a: 255 }),
                                    borderColor: new egis.sfs.Color({ r: 0, g: 0, b: 0, a: 255 }),
                                    fontFamilyName: '黑体',
                                    fontSize: 16,
                                    textAlign: 'center',
                                    offsetY: -22,
                                }),
                            });
                        },
                    });
                    opts.symbolBuilder = new SymbolBuilder();
                    opts.listeners = {
                        mouseover: (event: any) => {
                            const element: any = event[0].element;
                            const num = data.pois.map((poi: any) => poi.uid).indexOf(element.objectId) + 1;
                            this.removehighlight(false);
                            this.closePopup(false);
                            this._addHighlight(element.geometry.x, element.geometry.y, num, false);
                            this.openPopup(element, false);
                        },
                        mouseout: (event: any) => {
                            this.removehighlight(false);
                            this.closePopup(false);
                        },
                        click: (event: any) => {
                            const element: any = event[0].element;
                            const num = data.pois.map((poi: any) => poi.uid).indexOf(element.objectId) + 1;
                            this.closePopup();
                            this.removehighlight();
                            this.openPopup(element);
                            this._addHighlight(element.geometry.x, element.geometry.y, num);
                        },
                    };
                    this.options.simpleRenderMgr.add(opts);
                    this._fit();
                    break;
                case 4:
                    // 渲染行政区划面
                    if (!this.polygonFeatureLayer) {
                        this.polygonFeatureLayer = new egis.carto.FeatureLayer({
                            id: this.options.featureType,
                            visible: true,
                            opacity: 1,
                        });
                        // 创建渲染符号
                        const simpleFillSymbol = new egis.sfs.SimpleFillSymbol({
                            fillColor: new egis.sfs.Color({ r: 102, g: 179, b: 254, a: 56 }),
                            borderColor: new egis.sfs.Color({ r: 49, g: 143, b: 254, a: 255 }),
                            borderThickness: 3,
                            style: 1,
                        });
                        const simpleRender = new egis.render.SimpleRenderer({
                            map: this.map,
                            symbol: simpleFillSymbol,
                        });
                        this.polygonFeatureLayer.render(simpleRender);
                        this.map.addLayer(this.polygonFeatureLayer);
                    } else { this.polygonFeatureLayer.clear(); }

                    // 创建实体数据的字段
                    const polygonFields = new egis.sfs.Fields();
                    polygonFields.add(new egis.sfs.Field({ name: 'shape', dataType: egis.sfs.GEntityPropertyTypes.Polygon }));
                    polygonFields.add(new egis.sfs.Field({ name: 'name', dataType: 12 }));

                    data.admin.polygons.forEach((element: any) => {
                        // 创建面几何
                        const polygonFeature = new egis.sfs.GFeature({
                            fields: polygonFields,
                        });
                        polygonFeature.setValue('shape', element); // 为空的要素对象shape字段赋值
                        polygonFeature.setValue('name', data.admin.name); // 为空的要素对象shape字段赋值
                        this.polygonFeatureLayer.addFeature(polygonFeature);
                    });
                    this.map.pan(this.polygonFeatureLayer.getExtent());
                    break;
            }
        }
    },

    removeBuffer() {
        // this.closePopup();
        // this.removehighlight();
        if (this.polygonFeatureLayer) { this.polygonFeatureLayer.clear(); }
        if (this.options.bufferDraw) {
            this.options.bufferDraw.destroy();
            this.options.bufferDraw = null;
        }
        if (this.options.bufferDraw) { this.options.bufferDraw.clearBuffer(); }
    },

    _initBuffer(radius: number) {
        const self = this;
        if (!this.options.bufferDraw) {
            const bufferDraw = new G.interact.Buffer({
                id: this.options.bufferLayer,
                name: this.options.bufferLayer,
                map: this.map,
                radius,
                close: {
                    visible: false,
                    style: {
                        type: 'PictureMarkerSymbol',
                        options: {
                            width: 41,
                            height: 41,
                            opacity: 1,
                            rotation: 0,
                            offsetX: 0,
                            offsetY: 0,
                        },
                    },
                },
                drag: {
                    visible: true,
                    style: {
                        type: 'PictureMarkerSymbol',
                        options: {
                            width: 32,
                            height: 20,
                            opacity: 1,
                            rotation: 0,
                        },
                    },
                },
                axis: {
                    visible: true,
                    style: {
                        type: 'SimpleLineSymbol',
                        options: {
                            color: {
                                a: 153,
                                r: 123,
                                g: 0,
                                b: 11,
                            },
                            style: 5,
                            width: 2,
                        },
                    },
                },
                label: {
                    visible: true,
                    position: 'right',
                    style: {
                        type: 'TextSymbol',
                        options: {
                            text: '距离',
                            fontFamilyName: '黑体',
                            fontSize: 14,
                            foreground: {
                                a: 255,
                                r: 0,
                                g: 0,
                                b: 0,
                            },
                            borderColor: {
                                a: 255,
                                r: 122,
                                g: 122,
                                b: 122,
                            },
                            textBackgroundColor: new egis.sfs.Color({
                                a: 255,
                                r: 255,
                                g: 255,
                                b: 255,
                            }),
                            borderThickness: 0,
                            rotation: 0,
                            offsetX: 50,
                            offsetY: 0,
                        },
                    },
                },
                fill: {
                    visible: true,
                    style: {
                        type: 'SimpleFillSymbol',
                        options: {
                            borderColor: {
                                a: 153,
                                r: 0,
                                g: 0,
                                b: 255,
                            },
                            fillColor: {
                                a: 86,
                                r: 179,
                                g: 207,
                                b: 234,
                            },
                            borderThickness: 0,
                            opacity: 1,
                        },
                    },
                },
                // tslint:disable-next-line: no-shadowed-variable
                callback(bufferGeom: any, radius: any) {
                    self.fire('buffer_radius_change', radius);
                    this.map.pan(egis.sfs.GeometryFactory.createGeometryFromGeoJson(bufferGeom).envelope());
                },
                onClose() {
                    console.log('close');
                },
            });
            bufferDraw.load();
            this.options.bufferDraw = bufferDraw;
        }
    },
    _addBuffer(location: string, radius: number) {
        if (!!location && !!radius) {
            if (this.options.bufferDraw) { return; }
            this._initBuffer(radius);
            const param = {
                id: 'buffer',
                name: 'buffer',
                data: {
                    type: 'wkt',
                    geom: 'POINT(' + location.split(',')[0] + ' ' + location.split(',')[1] + ')',
                },
            };
            this.options.bufferDraw.buffer(param);
            const point = new egis.sfs.Point({
                x: Number(location.split(',')[0]),
                y: Number(location.split(',')[1]),
                spatialReference: egis.sfs.EnumSpatialReference.EPSG4326,
            });
            const pictureMarkerSymbol = new egis.sfs.PictureMarkerSymbol({
                source: this.options.symbolConfig.icons.current_poi,
                width: 26,
                height: 40,
                offsetX: 13,
                offsetY: 40,
                opacity: 1,
                rotation: 0,
            });
            const pointEle = new egis.sfs.Element({
                geometry: point,
                symbol: pictureMarkerSymbol,
            });
            const layers = this.map.getLayers().filter((layer: any) => {
                return layer.id === this.options.bufferLayer;
            });
            layers.forEach((layer: any) => {
                layer.groupLayers[0].add(pointEle);
            });
        }
    },

    // 调整视野
    _fit() {
        const layer: any = this.options.simpleRenderMgr.getLayer(this.options.featureType);
        const extent: any = G.utils.LayerUtil.getLayerExtent(layer);
        if (!!extent) {
            const pointdata: any = {
                type: 'geojson',
                geom: extent.asGeoJson(),
            };
            const options: any = {};
            this.options.featureLocate.fit(pointdata, options);
        }
    },

    // 添加高亮
    _addHighlight(x: any, y: any, num: number, isClick = true) {
        if (!!x && !!y && !!num) {
            const coordinate: any = [x, y];
            const pictureMarkerSymbol: any = {
                type: 'PictureMarkerSymbol',
                options: {
                    width: 22,
                    height: 34,
                    offsetX: 11,
                    offsetY: 34,
                    opacity: 1,
                    rotation: 0,
                    source: this.options.symbolConfig.icons.little_blue_poi,
                },
            };
            const textSymbol: any = {
                type: 'TextSymbol',
                options: {
                    text: num.toString(),
                    foreground: new egis.sfs.Color({ r: 255, g: 255, b: 255, a: 255 }),
                    borderColor: new egis.sfs.Color({ r: 0, g: 0, b: 0, a: 255 }),
                    fontFamilyName: '黑体',
                    fontSize: 16,
                    textAlign: 'center',
                    offsetY: -22,
                },
            };
            const options = [
                {
                    data: {
                        type: 'wkt',
                        geom: 'POINT(' + coordinate[0] + ' ' + coordinate[1] + ')',
                    },
                    style: pictureMarkerSymbol,
                    // 不闪烁
                    blink: {
                        enable: false,
                    },
                },
                {
                    data: {
                        type: 'wkt',
                        geom: 'POINT(' + coordinate[0] + ' ' + coordinate[1] + ')',
                    },
                    style: textSymbol,
                    // 不闪烁
                    blink: {
                        enable: false,
                    },
                },
            ];
            const highLightId = isClick ? this.options.highLightId : this.options.tempHighLightId;
            this.options.featureHighlight.addHighlight(highLightId, options);
        }
    },

    _createService(serviceType: string) {
        return Service.createService(serviceType, {}, this.options.serviceConfig.egis);
    },
});

export default component;
